module.exports = __webpack_public_path__ + "static/media/Samatvam-Jnana-Sanjeevini.79d42a2b.pdf";